import type { DisciplineType } from '../../services/api/models/DisciplineType';

export const CLINICIAN_DISCIPLINE_OPTIONS: ReadonlyArray<{
  value: DisciplineType;
  label: string;
}> = [
  { value: 'SN', label: 'Nursing' },
  { value: 'PT', label: 'PT' },
  { value: 'OT', label: 'OT' },
  { value: 'ST', label: 'ST' },
  { value: 'MSW', label: 'MSW' },
  { value: 'HHA', label: 'HHA' },
] as const;
